import React, { Component } from "react";
import { Modal, Tree, Spin } from "antd";

import { connect } from "dva";
import styles from "./index.less";

const { TreeNode } = Tree;

@connect(({ evaluateSetting }) => ({
  ...evaluateSetting
}))
class SelectNorm extends Component {
  constructor(props) {
    super(props);
    const { existedIndexCodeList } = this.props;
    this.state = {
      checkedKeys: [],
      selectedNormNode: existedIndexCodeList
    };
  }

  handleOk = () => {
    const { onOk } = this.props;
    const { selectedNormNode } = this.state;
    if (onOk) {
      onOk(selectedNormNode);
    }
  };

  onCheck = checkedKeys => {
    this.setState({ selectedNormNode: checkedKeys });
  };

  onSelect = (selectedKeys, info) => {
    this.setState({ selectedKeys });
  };

  renderTree = () => {
    const { tree } = this.props;
    const { selectedNormNode } = this.state;

    return (
      <Tree
        checkable
        onCheck={this.onCheck}
        onSelect={this.onSelect}
        checkedKeys={selectedNormNode}
        defaultExpandAll
      >
        {this.renderTreeNodes(tree)}
      </Tree>
    );
  };

  renderTreeNodes = data => {
    const { number, numberName, id, type } = data;
    return (
      <TreeNode
        title={numberName}
        key={id}
        treeNodeData={data}
        checkable={type === 2}
      >
        {(data.child || []).map(items => {
          return this.renderTreeNodes(items);
        })}
      </TreeNode>
    );
  };

  render() {
    const { onCancel } = this.props;
    const { tree, spinProps } = this.props;
    return (
      <Spin {...spinProps}>
        <Modal
          title="请选择通用指标"
          visible
          centered
          onOk={this.handleOk}
          onCancel={() => onCancel()}
          wrapClassName={styles.normModal}
        >
          <div className="modal-body-wrap">
            {tree ? this.renderTree() : <Spin tip="数据加载中..." />}
          </div>
        </Modal>
      </Spin>
    );
  }
}

export default SelectNorm;
